import React, { useState } from 'react';
import { planningTabsStyle as styles } from '../../css/styles/componentStyles';
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";

const PlanningTabs = ({activeBuisnessTab,setActiveBuisnessTab}) => {
const planningTabs = [
    {
      title: "Business",
      icon: (
        <BusinessCenterIcon style={{ fontSize: "22px", color: "#006580" }} />
      ),
    },
    {
      title: "CashFlow",
      icon: (
        <MonetizationOnIcon style={{ fontSize: "24px", color: "#006580" }} />
      ),
    },
  ];

 

  const handleTabClick = (title) => {
    setActiveBuisnessTab(title);
  };

  return (
    <div style={styles.container}>
      <div style={styles.tabsWrapper}>
        <div style={styles.backgroundGlow}></div>
        <div style={styles.tabsContainer}>
          {planningTabs.map((item, index) => {
            const isActive = activeBuisnessTab === item.title;
            return (
              <div
                key={index}
                style={{
                  ...styles.tab,
                  ...(isActive ? styles.tabActive : styles.tabInactive)
                }}
                onClick={() => handleTabClick(item.title)}
              >
                <div style={styles.tabContent}>
                  <span 
                    style={{
                      ...styles.tabIcon,
                      transform: isActive ? "scale(1.1)" : "scale(1)"
                    }}
                  >
                    {React.cloneElement(item.icon, {
                      style: {
                        fontSize: item.icon.props.style.fontSize,
                        color: isActive ? "#006580" : "#ffffff",
                        transition: "0.3s",
                      },
                    })}
                  </span>
                  <span style={styles.tabText}>
                    {item.title}
                  </span>
                </div>
                <div 
                  style={{
                    ...styles.shimmer,
                    left: isActive ? "100%" : "-100%"
                  }}
                ></div>
              </div>
            );
          })}
        </div>
      </div>
      
    
    </div>
  );
};

export default PlanningTabs;